import {Button, Dropdown, notification} from "antd";
import {DownOutlined} from "@ant-design/icons";
import {useClipboard} from "../../contexts/ClipboardContext";
import './grid-dropdown.css';

// width  : buton genişliği. Varsayılan 70px, çünkü çağıranların çoğu bir GUID
//          gösteriyor ve orada tam metin zaten sığmaz. Tarih gibi kısa ve tamamı
//          okunması gereken değerlerde 'auto' (içeriğe göre) ver.
// tail   : true iken metnin SONU gösterilir (GUID'lerde ayırt edici kısım sondadır);
//          tarih gibi baştan okunan değerlerde false ver.
export default function RowMenu({children, text, width = 70, tail = true})
{
    const { addText } = useClipboard();
    const renderButton = () => {
        if(text)
            return (
                <Button
                    size="small"
                    style={{
                        width: width,
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                    }}
                    onContextMenu={(e) => {
                        e.preventDefault();
                        // Düz sağ tık: geçmişi temizle, sadece bu değeri tut.
                        // Ctrl (veya ⌘) basılıysa: geçmişe ekle.
                        addText(text, { reset: !(e.ctrlKey || e.metaKey) });
                    }}
                    title={text}
                >
                    <span style={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        width: '100%',
                        direction: tail ? 'rtl' : 'ltr',
                        textAlign: 'left'
                    }}>
                        {text}
                    </span>
                </Button>
            )

        return (
            <Button onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
            }}>
                <DownOutlined />
            </Button>
        )
    }

    return (
        <Dropdown trigger={'click'} overlay={children} overlayClassName={'grid-dropdown-overlay'}>
            {renderButton()}
        </Dropdown>
    )
}
